import { useCanary } from '@bill/canary.react'

import { useExperimentTracking } from './ExperimentProvider'

export interface UseExperimentParams {
  experiment: string
  inputId: string
  bucketingKey?: string
}

export const useExperiment = ({ experiment, inputId, bucketingKey }: UseExperimentParams) => {
  const value = useCanary(experiment)

  const { track } = useExperimentTracking()

  track(experiment, inputId, value, bucketingKey)

  if (typeof value !== 'object') {
    return {
      isInExperiment: false,
      behaviorName: 'EXPERIMENT_OFF',
    }
  }

  return {
    isInExperiment: value?.placement === 'QUALIFIED',
    behaviorName: value?.behaviorName ?? value?.placement,
  }
}

export default useExperiment
